<ng-container *ngrxLet="hasNotifications$ as hasNotifications">
    <div *ngIf="hasNotifications" ngbDropdown>
        <div *ngrxLet="hasAlerts$ as hasAlerts" class="position-relative cursor-pointer" data-uit="notifications-alarm" ngbDropdownToggle>
            <ca-icon name="bell" size="s"></ca-icon>
            <div [ngClass]="hasAlerts ? 'alert-circle' : 'warn-circle'"></div>
        </div>
        <div ngbDropdownMenu>
            <ng-content></ng-content>
        </div>
    </div>
</ng-container>
